<template>
  <!-- 聚合支付海报 -->
  <el-dialog title="收款二维码" :visible.sync="juheModal" width="600px" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="juheModalcancel">
    <div v-loading="spinShow" class="container">
      <div class="share-img" v-show="imgUrlshow">
        <img :src="imgUrl">
      </div>
      <div class="creat-img" ref="box">
        <el-row type="flex" justify="space-between" align="middle" class="logo-line">
          <img src="../../../assets/images/pay_poster_logo.png" class="logo-left">
          <img :src="companyInfo.logo" crossOrigin="anonymous" class="logo-right">
        </el-row>
        <p class="title-line">{{ skuName }}</p>
        <div class="qrcode-box">
          <div :id="qrcodeId+orderId" class="qrcode"></div>
          <img :src="companyInfo.logo" crossOrigin="anonymous" class="logo-mini">
        </div>
        <div class="info-container">
          <div class="info-box">
            <p>1.本培训教学内容、学习平台由广电人才交流中心、新广汇贤公司提供，【{{ companyInfo.name }}】向您提供全程培训服务，培训费用收取和发票开具由【{{ companyInfo.name }}】负责；</p>
          </div>
          <div class="info-box">
            <p>2.请在支付后尽快前往培训官网(training.nrtatalent.cn)或通过“广电人才”APP完成培训协议签订。</p>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align:center;margin-top: 10px;">
      <el-button
        size="large"
        @click='copyYPLPath(shareHxQrCodeUrl)'
      >复制支付地址 </el-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <el-button :disabled="spinShow" type="success" size="large" @click="juheModalcopy()">保存二维码 </el-button> &nbsp;&nbsp;&nbsp;
    </div>
  </el-dialog>
</template>
<script>
import { qrcanvas } from 'qrcanvas'
import html2canvas from 'html2canvas'
import { getYPLPayPath } from '@/api/orderAdmin/orderList'
import { getCompanySignInfo } from '@/api/organization/index.js'
import Copy from 'copy-to-clipboard'
import oss from '@/api/base/api-upload'

export default {
  props: ['orderId', 'companyId', 'skuName', 'qrcodeId'],
  data () {
    return {
      juheModal: false,
      imgUrlshow: false,
      imgUrl: '',
      shareHxQrCodeUrl: '',
      companyInfo: {},
      spinShow: false
    }
  },
  watch: {
    imgUrl (val, oldval) {
      // 监听到imgUrl有变化以后 说明新图片已经生成 隐藏DOM
      this.$refs.box.style.display = 'none'
      this.imgUrlshow = true
      this.spinShow = false
    }
  },
  methods: {
    init () {
      this.juheModal = true
      this.spinShow = true
      this.imgUrlshow = false
      this.getYPLPath()
      this.getCompanySignInfo()
      this.$nextTick(() => {
        if (this.$refs.box) {
          this.$refs.box.style.display = 'block'
        }
      })
    },
    // 获取租户信息
    getCompanySignInfo () {
      getCompanySignInfo({ id: this.companyId }).then(({ code, data }) => {
        if (code === 0) {
          let logo = data.logo.replace('oss2.nrtatalent.cn', 'radioweb-pub.oss-cn-beijing.aliyuncs.com')
          let name = data.name
          if (logo.indexOf('http://radioweb-pub.oss-cn-beijing.aliyuncs.com') !== -1) {
            logo = data.logo.replace('http', 'https')
          }
          if (name === '国家广电人才网超管平台') {
            name = '北京新广汇贤人力资源管理有限责任公司'
          }
          this.companyInfo = { logo, name }
        }
      })
    },
    // 获取易票联支付地址
    getYPLPath () {
      const data = {
        orderId: this.orderId
      }
      getYPLPayPath(data).then(({ code, data }) => {
        if (code === 0) {
          this.shareHxQrCodeUrl = data.cashierUrl
          this.makeImage()
        }
      })
    },
    makeImage () {
      this.$nextTick(() => {
        // 生成二维码
        var canvas1 = qrcanvas({
          data: decodeURIComponent(this.shareHxQrCodeUrl),
          size: 254
        })
        document.getElementById(this.qrcodeId + this.orderId).innerHTML = ''
        document.getElementById(this.qrcodeId + this.orderId).appendChild(canvas1)
        const opts = { useCORS: true }
        setTimeout(() => {
          html2canvas(this.$refs.box, opts).then((canvas) => {
            var fileImage = this.blobToFile(this.dataURLtoBlob(canvas.toDataURL()))
            this.uploadImg(fileImage)
          })
        }, 3600)
      })
    },
    uploadImg (fileImage) {
      oss(fileImage, 0, 'wap/pub/upload').then(({ url }) => {
        this.imgUrl = url
      })
    },
    // 生成随机字符串
    randomString (len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    juheModalcancel () {
      this.juheModal = false
    },
    juheModalcopy () {
      if (!this.imgUrl) {
        this.$Message.success('图片下载失败;请稍后再试')
        return
      }
      this.downloadIamge(this.imgUrl, '收款二维码' + new Date().getTime())
    },
    downloadIamge (imgsrc, name) { // 下载图片地址和图片名
      var image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
        var canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        var context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        var url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
        var a = document.createElement('a') // 生成一个a元素
        var event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc
    },
    dataURLtoBlob (dataurl) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    blobToFile (theBlob) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = this.randomString(10) + 's.png'
      return theBlob
    },
    // 点击复制
    copyYPLPath (payload) {
      Copy(payload);
      this.$message({
        type: "success",
        message: "复制成功!",
      });
    }
  }
}

</script>
<style lang='scss' scoped>
.container {
  width: 375px;
  height: auto;
  padding-bottom: 12px;
  margin: auto;
  .title-line {
    padding: 6px 24px;
    line-height: 30px;
    text-align: center;
    font-weight: 600;
    font-size: 24px;
    color: #222222;
  }
  .qrcode-box {
    display: block;
    width: 278px;
    height: 278px;
    box-sizing: border-box;
    padding: 8px;
    margin: 4px auto;
    border-radius: 12px;
    border: 4px solid #E1F0FF;
    position: relative;
    .logo-mini {
      width: 62px;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
.logo-line {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  border-bottom: 1px solid #F6F6F6;
  .logo-left {
    width: 168px;
  }
  .logo-right {
    width: 126px;
  }
  img {
    height: auto;
    vertical-align: middle;
  }
}
.info-container {
  padding: 12px 16px;
  .info-box {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 9px;
    background: linear-gradient( 180deg, #FFFFFF 0%, #F6FAFF 100%);
    border-radius: 6px;
    border: 1px solid #EAF4FF;
    p {
      font-size: 14px;
      color: #222222;
      line-height: 20px;
    }
    & + .info-box {
      margin-top: 8px;
    }
  }
}
.share-img {
  width: 375px;
  height: auto;
  padding-bottom: 12px;
  margin: auto;
  box-shadow: 0px 0px 6px #eee;
  img {
    width: 100%;
  }
}
</style>
